import React from 'react'
import PropTypes from 'prop-types'
import PopoverLayout from './popover_layout'
import Shortcuts from '../../features/shortcuts'
import SidebarSectionTitle from '../sidebar_section_title'
import Button from '../button'
import Text from '../text'

class ShortcutsPopover extends React.PureComponent {

  render() {
    const { isXS } = this.props

    if (isXS) return null

    return (
      <PopoverLayout width={320}>
        <SidebarSectionTitle>
          <div className={[_s.displayFlex, _s.aiCenter, _s.flexRow, _s.pl10, _s.pr15].join(' ')}>
            <span>Shortcuts</span>
            <Button
              isText
              to='/shortcuts'
              color='brand'
              backgroundColor='none'
              className={_s.mlAuto}
            >
              <Text color='inherit' weight='bold' align='right'>All</Text>
            </Button>
          </div>
        </SidebarSectionTitle>
        <div className={[_s.d, _s.w100PC, _s.maxH80VH, _s.overflowYScroll].join(' ')}>
          <Shortcuts />
        </div>
      </PopoverLayout>
    )
  }
}

ShortcutsPopover.propTypes = {
  onClosePopover: PropTypes.func.isRequired,
  isXS: PropTypes.bool,
}

export default ShortcutsPopover